import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { connect } from 'react-redux';
import { fetchBenefits, fitnessGrantRegisterAndUpload } from 'actions/Benefits';
import { FormattedMessage } from 'react-intl';
import { addNotification } from 'reapop';
import PanelMessage from 'components/panels/PanelMessage';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import get from 'lodash/get';
import Loading from 'components/Loading';
import KBenefit from '../components/KJRN/KBenefit';
import KTitle from '../components/KJRN/KTitle';
import { initUpload } from '../actions/Files';
import { fetchProfileIfNeeded } from '../actions/profile';
import { requestSendEmail } from '../actions/Email';
import { benefitUpload } from '../actions/Benefits';

const styles = {
  container: {
    paddingTop: 16,
    paddingBottom: 16,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxWidth: 1344,
    margin: 'auto',
  },
  titleContainer: {
    width: '100%',
  },
  title: {
    fontSize: 32,
    marginTop: 12,
    marginBottom: 12,
  },
};
class Benefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentWillMount() {
    const { fetch } = this.props;
    fetch();
  }
  render() {
    const {
      benefits,
      loaded,
      onBenefitUpload,
      onSendEmail,
      employeeName,
      onRequestGrant,
      benefitLoadingById,
    } = this.props;
    if (!loaded) {
      return <Loading />;
    }
    if (!benefits || !benefits.length) {
      return (<PanelMessage
        message={<FormattedMessage id="benefit.empty" />}
        iconName="info"
        type="info"
      />);
    }
    const isGrants = (window.location.pathname === '/grants');
    const benefitTypes = isGrants ? [1, 2] : [0];
    const hb = filter(benefits, (benefit => includes(benefitTypes, benefit.HrBenefitType)));
    const grants = [
      <KTitle containerStyle={styles.titleContainer} key="hb" title={<FormattedMessage id={isGrants ? 'benefit.grant.title' : 'benefit.health.title'} />} />,
      map(hb, (benefit, key) => (
        <div key={key} style={{ margin: 24 }}>
          <KBenefit
            {...benefit}
            loading={get(benefitLoadingById, benefit.HrBenefitID, false)}
            onUpload={onBenefitUpload}
            onRequestGrant={onRequestGrant}
            onEmail={onSendEmail}
            employeeName={employeeName}
          />
        </div>
      )),
    ];
    return (
      <div style={styles.container}>
        {(!hb || !hb.length) ? <div /> : grants}
      </div>
    );
  }

}
function mapStateToProps(state) {
  return {
    valuesByKey: state.WebValuesReducer.valuesByKey,
    loaded: state.BenefitsReducer.loaded,
    benefits: state.BenefitsReducer.benefits,
    benefitLoadingById: state.BenefitsReducer.benefitLoadingById,
    employeeName: (state.profileReducer.employeeMaster) ? state.profileReducer.employeeMaster.EmployeeName : '',
  };
}

Benefits.contextTypes = {
  router: PropTypes.object.isRequired,
};

Benefits.propTypes = {
  loaded: PropTypes.bool,
  fetch: PropTypes.func.isRequired,
  valuesByKey: PropTypes.object,
  benefitLoadingById: PropTypes.object,
  benefits: PropTypes.array,
  onBenefitUpload: PropTypes.func.isRequired,
  onRequestGrant: PropTypes.func.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  employeeName: PropTypes.string,
};

export default connect(mapStateToProps, dispatch => ({
  fetch: () => { dispatch(fetchBenefits()); dispatch(initUpload()); dispatch(fetchProfileIfNeeded()); },
  onRequestGrant: async (...args) => dispatch(fitnessGrantRegisterAndUpload(...args)),
  onBenefitUpload: async (files, fileType, cb, Email, EmailCallBack) => dispatch(benefitUpload({ files, fileType }, cb, Email, EmailCallBack)),
  onSendEmail: email => dispatch(requestSendEmail(email, () => {
    dispatch(addNotification({
      title: 'Sent',
      message: 'Tölvupóstur hefur verið sendur með viðhengi',
      status: 'success',
      dismissible: true,
      dismissAfter: 4000,
    }));
  })),
}))(Benefits);



// WEBPACK FOOTER //
// ./src/containers/Benefits.js